import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';
import { IApplicationContext } from '../../types/application';
import {
  createGetMainPageBrandBannerEnrichmentsModel,
  fetchGetMainPageBrandBannerEnrichments,
  IGetMainPageBrandBannerEnrichmentsRequest,
  TGetMainPageBrandBannerEnrichmentsResponse,
} from '../../repositories/ad-banner/v1/get-main-page-brand-banner-enrichments';
import { IV1GetMainPageBrandBannerEnrichmentsResponse } from '../../repositories/ad-banner/entities/get_main_page_brand_banner_enrichments_v1/V1GetMainPageBrandBannerEnrichmentsResponse';

export async function fetchGetMainPageBrandBannerEnrichmentsService(
  applicationContext: IApplicationContext,
  parameters: IGetMainPageBrandBannerEnrichmentsRequest,
): Promise<IV1GetMainPageBrandBannerEnrichmentsResponse> {
  const { httpApi, logger } = applicationContext;

  const domain = 'src/shared/services/adBanner/fetchGetMainPageBrandBannerEnrichmentsService.ts';

  return fetchGetMainPageBrandBannerEnrichments<
    TGetMainPageBrandBannerEnrichmentsResponse,
    TGetMainPageBrandBannerEnrichmentsResponse
  >({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            message: `Ошибка в запросе: ${result.response?.message}`,
            domain,
            statusCode,
            details: {
              model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
            },
          });

          logger.warning(httpBadStatusCodeError.message, {
            domain: httpBadStatusCodeError.domain,
            details: httpBadStatusCodeError.printDetails(),
          });

          throw httpBadStatusCodeError;
        }
        default: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            message: `Неизвестный статус ответа: ${statusCode}`,
            domain,
            statusCode,
            details: {
              model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
            },
          });

          logger.error(httpBadStatusCodeError.message, {
            domain: httpBadStatusCodeError.domain,
            details: httpBadStatusCodeError.printDetails(),
          });

          throw httpBadStatusCodeError;
        }
      }
    },
    error => {
      const unknownError = new UnknownError({
        message: 'Неизвестная ошибка в запросе',
        domain,
        details: {
          model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
        },
      });

      logger.error(error, {
        domain: unknownError.domain,
        message: unknownError.message,
        details: unknownError.printDetails(),
      });

      throw unknownError;
    },
  );
}
